export default class LazyPreloader {
  constructor() {
    this._lazySizesInit = false;
  }

  init() {
    if (!window.lazySizes) {
      const pictureParents = document.querySelectorAll(`.picture-parent`);
      Array
        .from(pictureParents)
        .forEach((item) => {
          item.classList.add(`picture-parent_loaded`);
          const image = item.querySelector(`img`);

          if (!image) {
            return;
          }

          image.classList.remove(`lazyload`);
          image.srcset = image.dataset.srcset;
        });
      return;
    }

    this._lazySizesInit = true;

    document.addEventListener(`lazyloaded`, (evt) => {
      const image = evt.srcElement;
      const pictureParent = image.closest(`.picture-parent`);

      if (!pictureParent) {
        return;
      }

      pictureParent.classList.add(`picture-parent_loaded`);
    });
  }
}
